export default (theme) => ({
  stepper: {
    position: 'sticky',
    zIndex: 100,
    top: 130,
    background: theme.palette.background.white,
    minWidth: 400,
    height: 'auto',
    padding: 45,
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    borderRadius: 33,
    [theme.breakpoints.down('xl')]: {
      minWidth: 290,
      padding: '25px 30px',
      top: 100,
    },
    [theme.breakpoints.down('ml')]: {
      minWidth: 260,
      padding: '20px 25px',
      top: 100,
    },
  },
  connector: {
    margin: '4px 28px 0',
    [theme.breakpoints.down('xl')]: {
      margin: '2px 18px 0',
    },
  },
  step: {
    width: 58,
    height: 58,
    color: theme.palette.disabled.main,
    marginRight: 10,
    fontSize: 30,
    [theme.breakpoints.down('xl')]: {
      width: 38,
      height: 38,
    },
  },
  label: {
    '& span': {
      color: 'black',
      fontSize: 24,
      [theme.breakpoints.down('xl')]: {
        fontSize: 16,
      },
      [theme.breakpoints.down('ml')]: {
        fontSize: 14,
      },
    },
    '& .Mui-active': {
      fontWeight: 700,
    },
  },
});
